import React from 'react';
import { getFormattedPrice } from '../../../utils';
import cx from 'classnames';
import { BillingCycle, Service } from '~/types/models';
import {
  AnimatedDiv,
  ShowAnimation,
} from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';

export interface PricingPanelProps {
  monthlyPrice: number;
  annualPrice: number;
  service: Service;
  discounted: boolean;
  billingCycle?: BillingCycle;
}

export function PricingPanel({
  monthlyPrice,
  annualPrice,
  billingCycle,
  service,
  discounted,
}: PricingPanelProps) {
  const priceComponent = (price: number) => {
    return (
      <>
        <span
          className={cx(
            'text-[36px] font-bold leading-[1.15] transition-all v2-text-neutral-900',
            {
              '!v2-text-blue-500':
                discounted && service === Service.VideoMessaging,
              '!v2-text-magenta-500':
                discounted && service === Service.Testimonials,
            }
          )}
        >
          ${getFormattedPrice(price)}
        </span>
        <span className='text-[21px] font-bold v2-text-neutral-900'>/mo</span>
      </>
    );
  };

  return (
    <span className='flex flex-row justify-center items-end'>
      {billingCycle === BillingCycle.Monthly && (
        <AnimatedDiv
          showAnimation={ShowAnimation.SlideInRight150}
          show={billingCycle === BillingCycle.Monthly}
        >
          {priceComponent(monthlyPrice)}
        </AnimatedDiv>
      )}
      {billingCycle === BillingCycle.Yearly && (
        <AnimatedDiv
          showAnimation={ShowAnimation.SlideInLeft150}
          show={billingCycle === BillingCycle.Yearly}
        >
          {priceComponent(annualPrice / 12)}
        </AnimatedDiv>
      )}
    </span>
  );
}
